// useInviteAccess (contract 06 §9) — wraps AuthInviteAccessFlow. The "link already accessed"
// screen's Request Access action → one of two toasts. Copy is resolved from i18n keys here.
import { ref, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { AuthInviteAccessFlow } from '../flows/AuthInviteAccessFlow'

import { useToast } from '@/shared/ui'

export interface UseInviteAccess {
  pending: Ref<boolean>
  requestAccess: (accountId: string, adminEmail: string) => Promise<void>
}

export function useInviteAccess(): UseInviteAccess {
  const toast = useToast()
  const { t } = useI18n()
  const flow = new AuthInviteAccessFlow()

  const pending = ref(false)

  async function requestAccess(accountId: string, adminEmail: string): Promise<void> {
    if (pending.value) return
    pending.value = true
    try {
      const outcome = await flow.requestAccess(accountId, adminEmail)
      if (outcome.toast === 'requestSent') toast.success(t('auth.invite.requestSent'))
      else toast.warning(t('auth.invite.retryLater'))
    } finally {
      pending.value = false
    }
  }

  return { pending, requestAccess }
}
